const brandsId: Record<string, string> = {
  demo: '496',
  BDT: '3048',
};

export const getBrandId = (customerId: string): string => {
  return brandsId[customerId];
};
